var _path, _path2, _path3, _circle, _mask, _path4, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35378 5.21405L12.0939 3.29153C18.4671 1.47366 24.945 5.21005 26.5628 11.637L32.0874 33.5854L25.3473 35.5079C18.9741 37.3258 12.4961 33.5894 10.8784 27.1624L5.35378 5.21405Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.597 5.29031L7.78018 6.66423L12.9705 27.2846C14.3598 32.804 19.7915 36.0504 25.1025 34.5355L29.9193 33.1616L24.729 12.5412C23.3397 7.02175 17.908 3.77541 12.597 5.29031ZM5.35378 5.21405L11.0472 27.8332C12.7144 34.4565 19.2324 38.3521 25.6056 36.5343L32.3457 34.6117L26.6523 11.9926C24.9851 5.36927 18.4671 1.47366 12.0939 3.29153L5.35378 5.21405Z",
    fill: "#6092DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5937 16.5319C25.2313 12.7189 28.8392 10.1447 32.6523 10.7823L35.1131 11.1938L34.082 17.3597C33.4444 21.1727 29.8365 23.7469 26.0234 23.1093L23.5626 22.6979L24.5937 16.5319Z",
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9179,
    cy: 11.4293,
    r: 9.41786,
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_2023_2477",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2354 16.4293C5.2354 13.6678 7.47397 11.4293 10.2354 11.4293H11.8649V16.1117C11.8649 16.664 11.4172 17.1117 10.8649 17.1117H5.2354V16.4293Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2354 16.4293C5.2354 13.6678 7.47397 11.4293 10.2354 11.4293H11.8649V16.1117C11.8649 16.664 11.4172 17.1117 10.8649 17.1117H5.2354V16.4293Z",
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 4,
    mask: "url(#path-5-inside-1_2023_2477)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7591,
    cy: 8.58807,
    r: 1.89416,
    fill: "#6092DB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.18247,
    cy: 8.58807,
    r: 1.89416,
    fill: "#6092DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomations);
export default __webpack_public_path__ + "static/media/automations.a53ac051.svg";
export { ForwardRef as ReactComponent };